import React, {useEffect, useState} from 'react';
import FormControlLabel from "@mui/material/FormControlLabel";
import {Button, FormControl, FormLabel, Radio, RadioGroup} from "@mui/material";
import { AddressSuggestions } from 'react-dadata';
import 'react-dadata/dist/react-dadata.css';
import BackServer from "../../api/BackServer";
import CardDelivery from "../CardDelivery/CardDelivery";
import Box from "@mui/material/Box";


const Boxberry = (props) => {
    var delivery=JSON.parse(localStorage.getItem('delivery'))
    const [tipDostavki, setipDostavki] = React.useState( delivery.Type);
    const [shownext, setshownext] = React.useState(false);

    const [dadaAdress, setdadaAdress] = useState();
    const [deliveryText, setDeliveryText]= useState("")



    //console.log(props)

    const tipDostavkiChange = (event) => {
        setipDostavki(event.target.value);
        delivery.Type=event.target.value
        if (event.target.value=="Самовывоз"){
            delivery.Price="0"
            delivery.Adress="г.Москва, ул.Богородский вал 6к2, (м.Преображенская площадь)"
            delivery.ViewText="Самовывоз по адресу: г.Москва, ул.Богородский вал 6к2, (м.Преображенская площадь)"
            delivery.Phone= "+7(916)386-50-50"
            setshownext(true)
        }
        if (event.target.value=="Boxberry"){
            delivery.Price=delivery.BoxBerryPVZ.price
            if (delivery.BoxBerryPVZ.price=="0") {
                setshownext(false)
            } else {
                setshownext(true)
            }
            console.log(delivery.BoxBerryPVZ.address)
            delivery.Adress=delivery.BoxBerryPVZ.address
            delivery.Phone= delivery.BoxBerryPVZ.phone
            delivery.ViewText="Доставка в пункт выдачи по адресу: "+delivery.BoxBerryPVZ.address
        }

        localStorage.setItem('delivery',JSON.stringify(delivery));


    };

    function refrX(){
        delivery=JSON.parse(localStorage.getItem('delivery'))
        if (delivery.Type=="Boxberry"){
            if (delivery.BoxBerryPVZ.price=="0") {
                setshownext(false)
            } else {
                setshownext(true)
            }
        }
        if (delivery.Type=="Самовывоз"){
            delivery.Price="0"
            delivery.Adress="г.Москва, ул.Богородский вал 6к2, (м.Преображенская площадь)"
            delivery.ViewText="Самовывоз по адресу: г.Москва, ул.Богородский вал 6к2, (м.Преображенская площадь)"
            delivery.Phone= "+7(916)386-50-50"
            setshownext(true)
        }

    }
    useEffect(() => {
        refrX()
    }, [])
    const dadaAdressChange = (event) => {

    };
    const callbackBoxberry_function = (event)=>{
        var deliveryx=JSON.parse(localStorage.getItem('delivery'))
        deliveryx.BoxBerryPVZ=event
        deliveryx.Price=event.price
        deliveryx.Type= "Boxberry"
        deliveryx.Zip=event.zip
        deliveryx.Phone= event.phone
        deliveryx.Adress=event.address
        deliveryx.ViewText= "Доставка в пункт выдачи Boxberry по адресу: \n"+event.address
        localStorage.setItem('delivery',JSON.stringify(deliveryx));
        refrX()
    }

    const address = async () => {
       const  response = await BackServer.GetAdress("Мичурина 4 щелково")
      //  console.log(response)
    }




    const bx_pvz=
        <>
            {/* eslint-disable-next-line */}
            <button className={"Xbutton2"} onClick={()=>(boxberry.open(callbackBoxberry_function,props.api,'','',props.ordersum,props.weight,props.paysum,props.height,props.width,props.depth))}> Выбрать пункт выдачи</button>

        </>
    const sam_vvz=
        <>
            {/* eslint-disable-next-line */}
            {/*<button className={"Xbutton2"} onClick={()=>(boxberry.open(props.callback,props.api,'','',props.ordersum,props.weight,props.paysum,props.height,props.width,props.depth))}> Выбрать ПВЗ</button>*/}

        </>

    return (
        <>
            <FormControl>
                <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={tipDostavki}
                    onChange={tipDostavkiChange}
                >

                    <FormControlLabel
                        value="Самовывоз"
                        control={<Radio />}
                        label="Самовывоз в г. Москва"
                        onChange={tipDostavkiChange}
                        checked={tipDostavki === "Самовывоз"}
                    />
                    {tipDostavki == 'Самовывоз'? sam_vvz: <></>}
                    <FormControlLabel
                        value="Boxberry"
                        control={<Radio />}
                        label="В пункт выдачи Boxberry"
                        onChange={tipDostavkiChange}
                        checked={tipDostavki === "Boxberry"}
                    />
                    {tipDostavki == 'Boxberry'? bx_pvz: <></>}
                    {/*<FormControlLabel  value="Почта России" control={<Radio />} label="Почта России  (пока недоступно)" />*/}
                    <>ㅤ</>
                    <CardDelivery Adress={delivery.Adress} Type={delivery.Type} Price={delivery.Price} Phone={delivery.Phone}></CardDelivery>
                    <>ㅤ</>
                    {/*<AddressSuggestions token="a771efc98492525a50504e8c8fbceda10f539282" minChars={4} value={dadaAdress} onChange={dadaAdressChange} />;*/}
                </RadioGroup>
            </FormControl>

                    <Box sx={{ mb: 2 }}>
                        <div>
                            {shownext ==true?
                                <>
                            <Button
                                variant="contained"
                                onClick={props.callNext}
                                sx={{ mt: 1, mr: 1 }}
                            >
                                Перейти к доставке
                            </Button>
                                <Button
                                    variant="contained"
                                    onClick={props.callBackX}
                                    sx={{ mt: 1, mr: 1 }}
                                >
                                    Назад
                                </Button>
                                </>

                                : <a>Не выбран пункт выдачи заказов</a> }
                        </div>
                    </Box>




        </>
    );
};

export default Boxberry;